// Autres moyens de paiement pour la boutique : virement bancaire, lien de paiement libre, main propre / livraison.
// - BlocPaiementsAlternatifs : réglages de la distributrice (Mon compte + onglet Boutique du LinkBio)
// - RecapPaiementBoutique : écran affiché à la cliente après l'enregistrement de sa commande
// L'IBAN reste dans users/{uid} (privé). La boutique publique ne reçoit que des indicateurs (virement actif, lien, main propre) ;
// l'IBAN n'est renvoyé à la cliente qu'une fois sa commande enregistrée, par la fonction serveur.
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export function ibanNettoye(s) { return String(s || '').replace(/\s+/g, '').toUpperCase(); }
export function ibanFormate(s) { return ibanNettoye(s).replace(/(.{4})/g, '$1 ').trim(); }
export function ibanValide(s) {
  const i = ibanNettoye(s);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(i)) return false;
  const r = i.slice(4) + i.slice(0, 4);
  let reste = 0;
  for (const ch of r) {
    const v = /[A-Z]/.test(ch) ? String(ch.charCodeAt(0) - 55) : ch;
    for (const d of v) reste = (reste * 10 + Number(d)) % 97;
  }
  return reste === 1;
}
export function lienValide(s) { return /^https:\/\/[^\s/]+\.[^\s]+$/i.test(String(s || '').trim()); }

function copier(texte) {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(texte); return true; }
  } catch (e) { /* repli ci-dessous */ }
  try {
    const t = document.createElement('textarea');
    t.value = texte; t.style.position = 'fixed'; t.style.opacity = '0';
    document.body.appendChild(t); t.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(t);
    return ok;
  } catch (e) { return false; }
}

const champ = { width: '100%', border: '1px solid #D8CCFF', borderRadius: 8, padding: '.42rem .65rem', fontSize: '.76rem', fontFamily: 'inherit', marginBottom: '.6rem', outline: 'none', boxSizing: 'border-box', background: 'white' };
const etiquette = { fontSize: '.64rem', fontWeight: 700, color: '#3D1F0E', marginBottom: '.25rem' };
const aide = { fontSize: '.62rem', color: '#888', marginBottom: '.4rem', lineHeight: 1.5 };

export function BlocPaiementsAlternatifs({ uid }) {
  const [iban, setIban] = useState('');
  const [titulaire, setTitulaire] = useState('');
  const [bic, setBic] = useState('');
  const [lienLibre, setLienLibre] = useState('');
  const [lienLibreNom, setLienLibreNom] = useState('');
  const [mainPropre, setMainPropre] = useState(false);
  const [mainPropreNote, setMainPropreNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    if (!uid) return;
    let vivant = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'users', uid));
        if (!vivant || !snap.exists()) return;
        const d = snap.data();
        setIban(ibanFormate(d['db-paiement-iban'] || ''));
        setTitulaire(d['db-paiement-titulaire'] || '');
        setBic(d['db-paiement-bic'] || '');
        setLienLibre(d['db-paiement-lien-libre'] || '');
        setLienLibreNom(d['db-paiement-lien-libre-nom'] || '');
        setMainPropre(!!d['db-paiement-main-propre']);
        setMainPropreNote(d['db-paiement-main-propre-note'] || '');
      } catch (e) { /* champs vides */ }
    })();
    return () => { vivant = false; };
  }, [uid]);

  const sauver = async () => {
    setErreur('');
    const ibanNet = ibanNettoye(iban);
    const lien = lienLibre.trim();
    if (ibanNet && !ibanValide(ibanNet)) { setErreur("Cet IBAN ne semble pas valide : vérifie-le caractère par caractère (une erreur ici enverrait l'argent au mauvais endroit)."); return; }
    if (ibanNet && !titulaire.trim()) { setErreur("Indique le nom du titulaire du compte pour que ta cliente puisse faire le virement."); return; }
    if (lien && !lienValide(lien)) { setErreur("Le lien de paiement doit commencer par https://"); return; }
    setSaving(true);
    try {
      const prive = {
        'db-paiement-iban': ibanNet,
        'db-paiement-titulaire': titulaire.trim(),
        'db-paiement-bic': bic.trim().toUpperCase(),
        'db-paiement-lien-libre': lien,
        'db-paiement-lien-libre-nom': lienLibreNom.trim(),
        'db-paiement-main-propre': !!mainPropre,
        'db-paiement-main-propre-note': mainPropreNote.trim()
      };
      await setDoc(doc(db, 'users', uid), prive, { merge: true });
      // Version publique : jamais l'IBAN, seulement ce dont la boutique a besoin pour afficher les boutons
      await setDoc(doc(db, 'contacts_publics', uid), {
        'db-paiement-virement-actif': !!ibanNet,
        'db-paiement-lien-libre': lien,
        'db-paiement-lien-libre-nom': lienLibreNom.trim(),
        'db-paiement-main-propre': !!mainPropre,
        'db-paiement-main-propre-note': mainPropreNote.trim()
      }, { merge: true });
      setIban(ibanFormate(ibanNet));
      setSaved(true); setTimeout(() => setSaved(false), 2200);
    } catch (e) { setErreur('Erreur : ' + e.message); }
    setSaving(false);
  };

  return (
    <div style={{ background: '#F4F0FF', borderRadius: 12, padding: '1rem', marginBottom: '1rem', border: '1px solid #D8CCFF' }}>
      <div style={{ fontSize: '.7rem', fontWeight: 700, color: '#3D1F0E', marginBottom: '.3rem' }}>🤝 Autres moyens de paiement</div>
      <div style={{ ...aide, marginBottom: '.8rem' }}>
        Pour celles qui ne peuvent pas ou ne veulent pas utiliser Stripe / PayPal. Remplis seulement ce que tu veux proposer : un moyen laissé vide n'apparaît pas dans ta boutique.
        La commande arrive dans la fiche de ta cliente « en attente de paiement » : tu la valides toi-même dès que l'argent est arrivé.
      </div>

      <div style={etiquette}>🏦 Virement bancaire</div>
      <div style={aide}>Ton IBAN reste privé : ta cliente ne le voit qu'au moment où elle valide sa commande, avec une référence à indiquer dans le libellé du virement.</div>
      <input value={iban} onChange={e => setIban(e.target.value)} placeholder="IBAN (FR76 ...)" autoComplete="off" style={champ} />
      <input value={titulaire} onChange={e => setTitulaire(e.target.value)} placeholder="Nom du titulaire du compte" style={champ} />
      <input value={bic} onChange={e => setBic(e.target.value)} placeholder="BIC (facultatif)" style={champ} />

      <div style={etiquette}>🔗 Lien de paiement libre (Wero, Lydia, Revolut, Paylib…)</div>
      <div style={aide}>
        Colle ici ton lien de paiement ou de cagnotte. Vérifie que le service autorise bien les paiements pour une activité de vente : certains le limitent aux échanges entre proches.
      </div>
      <input value={lienLibreNom} onChange={e => setLienLibreNom(e.target.value)} placeholder="Nom affiché (ex : Wero, Lydia)" style={champ} />
      <input value={lienLibre} onChange={e => setLienLibre(e.target.value)} placeholder="https://..." style={champ} />

      <div style={etiquette}>📦 Main propre / à la livraison</div>
      <label style={{ display: 'flex', alignItems: 'center', gap: '.5rem', fontSize: '.72rem', color: '#3D1F0E', marginBottom: '.5rem', cursor: 'pointer' }}>
        <input type="checkbox" checked={mainPropre} onChange={e => setMainPropre(e.target.checked)} />
        Je propose le paiement en main propre ou à la livraison
      </label>
      {mainPropre && (
        <input value={mainPropreNote} onChange={e => setMainPropreNote(e.target.value)} placeholder="Précision (ex : remise lors de nos rencontres, secteur de livraison…)" style={champ} />
      )}

      {erreur && <div style={{ fontSize: '.7rem', color: '#C44B1A', marginBottom: '.6rem', lineHeight: 1.5 }}>{erreur}</div>}
      <button onClick={sauver} disabled={saving}
        style={{ width: '100%', background: saved ? '#2E7D32' : '#3D1F0E', color: 'white', border: 'none', borderRadius: 8, padding: '.5rem', fontSize: '.76rem', fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer' }}>
        {saving ? '...' : saved ? '✅ Enregistré !' : 'Enregistrer ces moyens de paiement'}
      </button>
    </div>
  );
}

function LigneCopiable({ titre, valeur, mono }) {
  const [ok, setOk] = useState(false);
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', padding: '.45rem 0', borderBottom: '1px solid #F0EBE3' }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '.58rem', color: '#888', textTransform: 'uppercase', letterSpacing: '.06em' }}>{titre}</div>
        <div style={{ fontSize: '.8rem', fontWeight: 700, color: '#3D1F0E', wordBreak: 'break-all', fontFamily: mono ? 'monospace' : 'inherit' }}>{valeur}</div>
      </div>
      <button onClick={() => { if (copier(String(valeur))) { setOk(true); setTimeout(() => setOk(false), 1800); } }}
        style={{ background: ok ? '#2E7D32' : '#F4F0FF', color: ok ? 'white' : '#3D1F0E', border: '1px solid #D8CCFF', borderRadius: 8, padding: '.3rem .6rem', fontSize: '.66rem', fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer', flexShrink: 0 }}>
        {ok ? '✓ Copié' : 'Copier'}
      </button>
    </div>
  );
}

export function RecapPaiementBoutique({ r, onClose }) {
  const montant = (Number(r.total) || 0).toFixed(2) + ' €';
  const prenom = r.prenomDistrib || 'ta conseillère';
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '.9rem' }}>
        <div style={{ fontSize: '2rem' }}>{r.methode === 'main_propre' ? '🤝' : r.methode === 'virement' ? '🏦' : '🔗'}</div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: '1.05rem', color: '#3D1F0E', marginTop: '.2rem' }}>Ta commande est enregistrée</div>
        <div style={{ fontSize: '.72rem', color: '#666', marginTop: '.3rem', lineHeight: 1.5 }}>
          {r.methode === 'virement' && 'Il ne reste plus qu\'à faire le virement ci-dessous.'}
          {r.methode === 'lien_libre' && 'Il ne reste plus qu\'à régler via le lien ci-dessous.'}
          {r.methode === 'main_propre' && prenom + ' te contacte pour convenir de la remise et du paiement.'}
        </div>
      </div>

      <div style={{ background: '#FAF7F2', border: '1px solid #E8DDD4', borderRadius: 12, padding: '.4rem .85rem', marginBottom: '.85rem' }}>
        <LigneCopiable titre="Montant à régler" valeur={montant} />
        {r.reference && <LigneCopiable titre={r.methode === 'main_propre' ? 'Ta référence de commande' : 'Référence à indiquer dans le message'} valeur={r.reference} mono />}
        {r.methode === 'virement' && r.iban && <LigneCopiable titre="IBAN" valeur={r.iban} mono />}
        {r.methode === 'virement' && r.titulaire && <LigneCopiable titre="Titulaire du compte" valeur={r.titulaire} />}
        {r.methode === 'virement' && r.bic && <LigneCopiable titre="BIC" valeur={r.bic} mono />}
      </div>

      {r.methode === 'lien_libre' && r.lien && /^https:\/\//i.test(r.lien) && (
        <a href={r.lien} target="_blank" rel="noopener noreferrer"
          style={{ display: 'block', textAlign: 'center', background: '#3D1F0E', color: 'white', textDecoration: 'none', borderRadius: 10, padding: '.8rem', fontSize: '.85rem', fontWeight: 700, marginBottom: '.7rem' }}>
          Ouvrir {r.lienNom || 'le lien de paiement'} →
        </a>
      )}

      {r.methode === 'main_propre' && r.note && (
        <div style={{ fontSize: '.72rem', color: '#3D1F0E', background: '#F4F0FF', border: '1px solid #D8CCFF', borderRadius: 10, padding: '.6rem .8rem', marginBottom: '.7rem', lineHeight: 1.5 }}>{r.note}</div>
      )}

      <div style={{ fontSize: '.68rem', color: '#888', lineHeight: 1.6, marginBottom: '.9rem' }}>
        {r.methode === 'main_propre'
          ? 'Garde cette référence : tu pourras la donner à ' + prenom + '.'
          : 'Pense à écrire la référence dans le message du paiement : ' + prenom + ' pourra ainsi retrouver ta commande et la préparer dès réception.'}
      </div>

      <button onClick={onClose}
        style={{ width: '100%', background: 'none', border: '1px solid #E8DDD4', borderRadius: 10, padding: '.65rem', fontSize: '.78rem', fontWeight: 700, color: '#3D1F0E', fontFamily: 'inherit', cursor: 'pointer' }}>
        Fermer
      </button>
    </div>
  );
}
